module.exports = __webpack_public_path__ + "img/tziyur_no.45da244f.png";